export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-vietnamese-400-normal.woff2?eaff40ae8ca94d1f3cdfbe73c91b6b78";